import { AuthProvider, useAuth } from './auth'
import { Logo } from './components/Logo'
import { Shell } from './components/Shell'
import { EmptyState, Link, Spinner } from './components/Ui'
import { AccountPage } from './pages/AccountPage'
import { ConnectPage } from './pages/ConnectPage'
import { LicensePage } from './pages/LicensePage'
import { LicensesPage } from './pages/LicensesPage'
import { LoginPage } from './pages/LoginPage'
import { PairPage } from './pages/PairPage'
import { currentUrl, navigate, safeReturnUrl, useRoute } from './router'

export function App() {
  return (
    <AuthProvider>
      <Routes />
    </AuthProvider>
  )
}

function Routes() {
  const route = useRoute()
  const { me, user } = useAuth()

  // the connect page handles both states itself: it shows the sign-in methods inline when needed
  if (route.path === '/connect') return <ConnectPage />
  // and so does the pairing page, for the same reason: an installation sends someone here who may
  // not be signed in yet, and sending them through the login page first would lose the pairing id
  if (route.path === '/pair') return <PairPage />

  if (me === undefined) {
    return (
      <div className="centered">
        <div className="loading">
          <Logo height={34} />
          <Spinner label="Connecting to Relatude.License…" />
        </div>
      </div>
    )
  }

  if (route.path === '/login') {
    if (user) {
      navigate(safeReturnUrl(route.query.get('returnUrl')), true)
      return null
    }
    return <LoginPage />
  }

  // everything else is for a signed-in user
  if (!user) return <LoginPage returnUrl={currentUrl()} />

  const license = /^\/licenses\/([^/]+)$/.exec(route.path)
  return (
    <Shell>
      {route.path === '/' ? (
        <LicensesPage />
      ) : license ? (
        <LicensePage id={license[1]} />
      ) : route.path === '/account' ? (
        <AccountPage />
      ) : (
        <NotFound />
      )}
    </Shell>
  )
}

function NotFound() {
  return (
    <div className="card">
      <EmptyState
        icon="info"
        title="There is nothing at this address"
        action={
          <Link to="/" className="button button-primary">
            Go to your licenses
          </Link>
        }
      >
        The link may be old, or what it pointed to may have been removed. Your licenses and your account are where they always are.
      </EmptyState>
    </div>
  )
}
